<template>
  <div class="height-vh-100 d-flex flex-column justify-content-between">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <br>
    <br>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppFooter from "@/components/app/footer.vue";

export default {
  components: {
    AppFooter
  }
};
</script>
